export enum userTestDepositFormFields {
  amount = 'amount',
  processNow = 'processNow',
}
